import React from 'react';
import { useParams } from 'react-router-dom';

export const UploadsPage = () => {
  const { photo } = useParams();

  return (
    <div className="flex justify-center items-center w-screen min-h-screen bg-black">
      <div className="max-w-4xl">
        <img
          src={`/uploads/${photo}`}
          alt="Фото"
          className='w-full h-screen'
        />
      </div>
    </div>
  );
};

